(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var KEY = 'jax:email-popup';
  var PENDING_KEY = 'jax:email-popup-pending';

  function read(storage, key) {
    try { return JSON.parse(window[storage].getItem(key)); } catch (error) { return null; }
  }

  function write(storage, key, value) {
    try { window[storage].setItem(key, JSON.stringify(value)); } catch (error) { return; }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(PENDING_KEY); } catch (error) { return; }
  }

  function init(root) {
    if (!root || root.__emailPopup) return;
    root.__emailPopup = true;

    var days = parseInt(root.getAttribute('data-remember-days'), 10) || 30;
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 15;
    var form = root.querySelector('form');
    if (!form) return;
    var input = root.querySelector('input[type="email"]');
    var submit = root.querySelector('[type="submit"]');
    var error = root.querySelector('[data-email-popup-error]');
    var success = root.querySelector('.epop__success');
    var teaser = document.querySelector('[data-email-popup-open="' + root.id + '"]');
    var state = read('localStorage', KEY);
    var pending = read('sessionStorage', PENDING_KEY);
    var ownResponse = (pending && pending.form === form.id && Date.now() - pending.at < 900000) || window.location.hash === '#' + form.id;
    var knownSubscriber = root.getAttribute('data-subscribed') === 'true' || !!(state && state.subscribed && state.until > Date.now());
    var onProtectedPage = /\/(products|cart|checkouts?|challenge|account)(\/|$)/.test(window.location.pathname) ||
      /\/pages\/(engraving-studio|logo-cup-mockup|team-corporate|contact)(\/|$)/.test(window.location.pathname) ||
      !!document.getElementById('quote');
    var justSubmitted = /(?:contact|customer)_posted=/.test(window.location.search);
    var lastFocus = null;
    var timer = null;
    var submitRecovery = null;
    var submitting = false;
    var composing = false;
    var submitLabel = submit ? submit.textContent : '';

    function remember(subscribed) {
      write('localStorage', KEY, { until: Date.now() + days * 86400000, subscribed: !!subscribed });
    }

    function showTeaser() {
      if (teaser) teaser.hidden = onProtectedPage || knownSubscriber || !!success;
    }

    function cleanupTimer() {
      if (timer) window.clearTimeout(timer);
      timer = null;
    }

    function open(manual) {
      if (root.classList.contains('is-visible')) return;
      cleanupTimer();
      lastFocus = document.activeElement;
      root.hidden = false;
      root.classList.add('is-visible');
      if (teaser) {
        teaser.hidden = true;
        teaser.setAttribute('aria-expanded', 'true');
      }
      if (manual) (success || input || root.querySelector('[data-email-popup-close]')).focus({ preventScroll: true });
    }

    function close() {
      var restoreFocus = root.contains(document.activeElement);
      root.classList.remove('is-visible');
      root.hidden = true;
      cleanupTimer();
      if (!knownSubscriber) remember(false);
      if (teaser) teaser.setAttribute('aria-expanded', 'false');
      showTeaser();
      if (restoreFocus && lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
    }

    function resetSubmission() {
      if (submitRecovery) window.clearTimeout(submitRecovery);
      submitRecovery = null;
      submitting = false;
      if (submit) {
        submit.disabled = false;
        submit.textContent = submitLabel;
      }
      form.removeAttribute('aria-busy');
    }

    function maybeOpen() {
      if (!root.isConnected) return;
      var active = document.activeElement;
      var editing = active && active.matches('input, textarea, select, [contenteditable="true"]');
      var modal = Array.prototype.some.call(document.querySelectorAll('dialog[open], [aria-modal="true"]'), function (element) {
        return element.getClientRects().length > 0;
      });
      if (document.hidden || editing || modal) {
        timer = window.setTimeout(maybeOpen, 3000);
        return;
      }
      open(false);
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-email-popup-close]')) close();
    });
    function onKeyDown(event) {
      if (event.key === 'Escape' && !event.isComposing && !root.hidden) {
        event.preventDefault();
        close();
      }
    }
    document.addEventListener('keydown', onKeyDown);
    if (teaser) teaser.addEventListener('click', function () { open(true); });

    if (input && submit) {
      input.addEventListener('compositionstart', function () { composing = true; });
      input.addEventListener('compositionend', function () { composing = false; });
      input.addEventListener('input', function () {
        input.removeAttribute('aria-invalid');
        if (error) error.hidden = true;
      });
      form.addEventListener('submit', function (event) {
        if (submitting || composing) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        input.value = input.value.trim();
        if (!input.validity.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.setAttribute('aria-invalid', 'true');
          if (error) {
            error.textContent = root.getAttribute('data-error-message');
            error.hidden = false;
          }
          input.focus();
          return;
        }
        submitting = true;
        form.setAttribute('aria-busy', 'true');
        submit.disabled = true;
        submit.textContent = root.getAttribute('data-sending-label');
        write('sessionStorage', PENDING_KEY, { form: form.id, at: Date.now() });
        submitRecovery = window.setTimeout(resetSubmission, 15000);
      }, true);
      window.addEventListener('pageshow', resetSubmission);
    }

    root.__emailPopupDestroy = function () {
      cleanupTimer();
      if (submitRecovery) window.clearTimeout(submitRecovery);
      document.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('pageshow', resetSubmission);
    };
    if (success && ownResponse) {
      clearPending();
      knownSubscriber = true;
      remember(true);
      open(true);
      return;
    }
    if (error && !error.hidden && ownResponse) {
      clearPending();
      open(true);
      return;
    }
    if (knownSubscriber || onProtectedPage || justSubmitted || success) return;
    if (state && state.until > Date.now()) {
      showTeaser();
      return;
    }
    timer = window.setTimeout(maybeOpen, Math.max(0, delay) * 1000);
  }

  function initAll(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var list = Array.prototype.slice.call(scope.querySelectorAll('[data-email-popup]'));
    if (scope.matches && scope.matches('[data-email-popup]')) list.unshift(scope);
    list.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-email-popup]');
    if (root && root.__emailPopupDestroy) root.__emailPopupDestroy();
  });
})();

